import { AccessSubjectType } from '../types';

export enum FeatureAccessMessageType {
  COMING_SOON = 'COMING_SOON',
  SUBSCRIPTION_NEEDED = 'SUBSCRIPTION_NEEDED',
  CURRENT_SUBCRIPTION_NOT_ENOUGH = 'CURRENT_SUBCRIPTION_NOT_ENOUGH',
  AVAILABLE = 'AVAILABLE',
}

export enum FeatureId {
  EXPORT_DATA = 'EXPORT_DATA',
  DOWNLOAD_REPORT = 'DOWNLOAD_REPORT',
  TIME_TRACKING = 'TIME_TRACKING',
  COMPARISON = 'COMPARISON',
  SUGGEST_FIXES = 'SUGGEST_FIXES',
  EU_TAXONOMY = 'EU_TAXONOMY',
  EDIT_CURRENT_WEIGHT_SET = 'EDIT_CURRENT_WEIGHT_SET',
  EDIT_ALL_WEIGHT_SETS = 'EDIT_ALL_WEIGHT_SETS',
  DOWNLOAD_IMAGE = 'DOWNLOAD_IMAGE',
  PRODUCT_SEARCH = 'PRODUCT_SEARCH',
  PRODUCT_VIEW = 'PRODUCT_VIEW',
  SEARCHBAR = 'SEARCHBAR', // TODO: Rename to something with no risk of confusion, such as SEARCH_GROUPFOLIOS
  API = 'API',
  SDG_ALIGNMENT = 'SDG_ALIGNMENT',
  NET_IMPACT = 'NET_IMPACT',
  IMPACT_EXPORT = 'IMPACT_EXPORT',
  EU_PAI = 'EU_PAI',
  SCREENER = 'SCREENER',
  BLANKET_LIMITED = 'BLANKET_LIMITED',
  COMPANY_PLATFORM_DASHBOARD = 'COMPANY_DASHBOARD',
  COMPANY_PLATFORM_INPUT_PRODUCTS = 'COMPANY_PLATFORM_INPUT_PRODUCTS',
  COMPANY_PLATFORM_INPUT_TARGETS_INSIGHTS = 'COMPANY_PLATFORM_INPUT_TARGETS_INSIGHTS',
  CSRD_DOUBLE_MATERIALITY = 'CSRD_DOUBLE_MATERIALITY',
  CSRD_REASONINGS = 'CSRD_REASONINGS', // OH 22.10.24: Temporary access control before publishing reasoning features to all customers
  GISE_STATEMENTS = 'GISE_STATEMENTS', // OH 22.10.24: Temporary access control before publishing (CSRD) GISE statements feature to all customers

  // Temporary fetureIds to enable features with legacy logic
  DOWNLOAD_AS_EXCEL = 'DOWNLOAD_AS_EXCEL',
  ADVANCED_MIXIN_TEMPLATES = 'ADVANCED_MIXIN_TEMPLATES',

  HISTOGRAM = 'HISTOGRAM',
}

export const allFeatureIds = getAllEnumValues(FeatureId, 'string');

function getAllEnumValues<T extends object>(inputEnum: T, enumType: 'string' | 'number') {
  const values = Object.values(inputEnum) as Array<T[keyof T]>;
  return values.filter(v => typeof v === enumType);
}

export interface FeatureAccessMessage {
  type: FeatureAccessMessageType;
  subjectId: number;
  subjectType: AccessSubjectType;
  featureId: FeatureId;
}

export function getFeatureAccessLevel(accessType: FeatureAccessMessageType) {
  switch (accessType) {
    case FeatureAccessMessageType.AVAILABLE:
      return 1;
    case FeatureAccessMessageType.COMING_SOON:
      return 2;
    case FeatureAccessMessageType.CURRENT_SUBCRIPTION_NOT_ENOUGH:
      return 3;
    case FeatureAccessMessageType.SUBSCRIPTION_NEEDED:
      return 99;
  }
}
